import subscriptionSvg from '@/components/Icon/svgs/Subscription.svg';
import languageSvg from '@/components/Icon/svgs/mic.svg';
import AvatarSvg from '@/components/Icon/svgs/pa-account.svg';
import PropCodeSvg from '@/components/Icon/svgs/tag.svg';
import uiLanguageSvg from '@/components/Icon/svgs/ui_language.svg';

export enum MenuItem {
  AboutMe = 'About Me',
  Profile = 'Account Settings',
  PreferredLanguage = 'Preferred Language',
  AppLanguage = 'App Language',
  Subscription = 'Subscription',
  PromoCode = 'Promo Code'
}
export const IconMap = {
  [MenuItem.AboutMe]: AvatarSvg,
  [MenuItem.Profile]: AvatarSvg,
  [MenuItem.PreferredLanguage]: languageSvg,
  [MenuItem.AppLanguage]: uiLanguageSvg,
  [MenuItem.Subscription]: subscriptionSvg,
  [MenuItem.PromoCode]: PropCodeSvg
};

export const MenuTNameMap = {
  [MenuItem.AboutMe]: 'menu.aboutMe',
  [MenuItem.Profile]: 'menu.accountSettings',
  [MenuItem.PreferredLanguage]: 'menu.aiLanguage',
  [MenuItem.AppLanguage]: 'menu.uiLanguage',
  [MenuItem.Subscription]: 'menu.subscription',
  [MenuItem.PromoCode]: 'promoCode'
};
